const text: Array<string> = [
  "Reticulating splines...",
  "Swapping time and space...",
  "Bending the spoon...",
  "We're building the buildings as fast as we can",
  "Please wait while the little elves draw your map",
  "Don't worry - a few bits tried to escape, but we caught them",
  "Checking the gravitational constant in your locale...",
  "The bits are flowing slowly today",
  "Counting backwards from Infinity",
  "Creating time-loop inversion field",
  "Spinning the wheel of fortune...",
  "Computing chance of success",
  "Looking for exact change",
  "Adjusting flux capacitor...",
  "Keeping all the 1's and removing all the 0's...",
  "Cleaning off the cobwebs...",
  "Granting wishes...",
  "Spinning the hamster…",
  "You shall not pass! yet..",
  "Load it and they will come",
  "Convincing AI not to turn evil..",
  "Computing the secret to life, the universe, and everything.",
  "When nothing is going right, go left!!...",
  "Constructing additional pylons...",
  "If you type Google into Google you can break the internet",
  "Dividing by zero...",
  "Simulating traveling salesman...",
  "Twiddling thumbs...",
  "Searching for plot device...",
  "Please wait while the intern refills his coffee.",
  "Please hold on as we reheat our coffee",
  "Ordering 1s and 0s...",
  "Please wait... Consulting the manual...",
  "Downloading more RAM..",
  "Updating to Windows Vista...",
  "Initializing the initializer...",
  "Optimizing the optimizer...",
  "Shovelling coal into the server",
  "Updating Updater...",
  "Downloading Downloader...",
  "Reading Terms and Conditions for you.",
  "Patience! This is difficult, you know...",
  "Sorry we are busy catching em' all, we're done soon",
  "Still faster than Windows update",
  "CAPS LOCK – Preventing Login Since 1980.",
  "Preventing robot uprising ...",
  "Hacking into the Main Frame...",
  "Do you smell carrots? -a snowman"
];
export default text;
